export default "__VITE_ASSET__Ch8ts9oP__"